/**
 * @generated SignedSource<<e6791e5fde1c683efd8b9151b2731d76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InsightsTabNotificationsQuery$variables = {
  brandId: string;
  comparisonEndDate: any;
  comparisonStartDate: any;
  endDate?: any | null;
  startDate?: any | null;
};
export type InsightsTabNotificationsQuery$data = {
  readonly brand: {
    readonly comparisonMetrics: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly pushNotificationDeliveries: number;
          readonly pushNotificationTaps: number;
        };
      }>;
    };
    readonly id: string;
    readonly metricsDaily: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly pushNotificationDeliveries: number;
          readonly pushNotificationTaps: number;
        };
      }>;
    };
    readonly " $fragmentSpreads": FragmentRefs<"InsightsTabAutomatedNotificationsTable_brand" | "InsightsTabNotificationsTable_brand">;
  };
};
export type InsightsTabNotificationsQuery = {
  response: InsightsTabNotificationsQuery$data;
  variables: InsightsTabNotificationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "brandId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "comparisonEndDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "comparisonStartDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "brandId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "gte",
      "variableName": "startDate"
    },
    {
      "kind": "Variable",
      "name": "lte",
      "variableName": "endDate"
    }
  ],
  "kind": "ObjectValue",
  "name": "date"
},
v8 = {
  "kind": "Literal",
  "name": "os",
  "value": {
    "isNull": true
  }
},
v9 = [
  {
    "fields": [
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filters"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pushNotificationDeliveries",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pushNotificationTaps",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GraphQLBrandMetricDailyEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLBrandMetricDaily",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v13 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "gte",
            "variableName": "comparisonStartDate"
          },
          {
            "kind": "Variable",
            "name": "lte",
            "variableName": "comparisonEndDate"
          }
        ],
        "kind": "ObjectValue",
        "name": "date"
      },
      (v8/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filters"
  }
],
v14 = [
  {
    "kind": "Literal",
    "name": "after",
    "value": ""
  },
  {
    "kind": "Literal",
    "name": "filters",
    "value": {
      "isPushed": true
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attributedSales",
  "storageKey": null
},
v17 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GraphQLBrandMetricDailyEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLBrandMetricDaily",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "InsightsTabNotificationsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InsightsTabNotificationsTable_brand"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InsightsTabAutomatedNotificationsTable_brand"
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "GraphQLBrandMetricDailyConnection",
            "kind": "LinkedField",
            "name": "metricsDaily",
            "plural": false,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": "comparisonMetrics",
            "args": (v13/*: any*/),
            "concreteType": "GraphQLBrandMetricDailyConnection",
            "kind": "LinkedField",
            "name": "metricsDaily",
            "plural": false,
            "selections": (v12/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "InsightsTabNotificationsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currencyCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v14/*: any*/),
            "concreteType": "GraphQLNotificationConnection",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLNotificationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLNotification",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "uuid",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GraphQLCDPAudience",
                        "kind": "LinkedField",
                        "name": "audiences",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "audienceName",
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "body",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "thumbnailUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "timestamp",
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GraphQLAttributedNotificationMetric",
                        "kind": "LinkedField",
                        "name": "attributedNotification",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "attributedOrders",
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "notifications(after:\"\",filters:{\"isPushed\":true},first:10)"
          },
          {
            "alias": null,
            "args": (v14/*: any*/),
            "filters": [
              "filters"
            ],
            "handle": "connection",
            "key": "InsightsTabNotificationsTable_notifications",
            "kind": "LinkedHandle",
            "name": "notifications"
          },
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  (v7/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "filters"
              }
            ],
            "concreteType": "GraphQLAutomationMetricDailyConnection",
            "kind": "LinkedField",
            "name": "automationMetricsDaily",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLAutomationMetricDailyEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLAutomationMetricDaily",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "notificationType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "notificationPosition",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v16/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filters",
                    "value": {
                      "isEnabled": true
                    }
                  }
                ],
                "concreteType": "GraphQLAutomatedNotificationConnection",
                "kind": "LinkedField",
                "name": "automatedNotifications",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLAutomatedNotificationEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GraphQLAutomatedNotification",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "notifType",
                            "storageKey": null
                          },
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "delaySeconds",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "automatedNotifications(filters:{\"isEnabled\":true})"
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "GraphQLBrandMetricDailyConnection",
            "kind": "LinkedField",
            "name": "metricsDaily",
            "plural": false,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": "comparisonMetrics",
            "args": (v13/*: any*/),
            "concreteType": "GraphQLBrandMetricDailyConnection",
            "kind": "LinkedField",
            "name": "metricsDaily",
            "plural": false,
            "selections": (v17/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c9d9b19d4a67dacbf2ae8e2cec854e9d",
    "id": null,
    "metadata": {},
    "name": "InsightsTabNotificationsQuery",
    "operationKind": "query",
    "text": "query InsightsTabNotificationsQuery(\n  $brandId: ID!\n  $endDate: Date\n  $startDate: Date\n  $comparisonEndDate: Date!\n  $comparisonStartDate: Date!\n) {\n  brand(id: $brandId) {\n    ...InsightsTabNotificationsTable_brand\n    ...InsightsTabAutomatedNotificationsTable_brand\n    id\n    metricsDaily(filters: {date: {lte: $endDate, gte: $startDate}, os: {isNull: true}}) {\n      edges {\n        node {\n          pushNotificationDeliveries\n          pushNotificationTaps\n          id\n        }\n      }\n    }\n    comparisonMetrics: metricsDaily(filters: {date: {lte: $comparisonEndDate, gte: $comparisonStartDate}, os: {isNull: true}}) {\n      edges {\n        node {\n          pushNotificationDeliveries\n          pushNotificationTaps\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment InsightsTabAutomatedNotificationsTable_brand on BrandType {\n  id\n  currencyCode\n  displayName\n  automationMetricsDaily(filters: {date: {lte: $endDate, gte: $startDate}}) {\n    edges {\n      node {\n        notificationType\n        notificationPosition\n        pushNotificationDeliveries\n        pushNotificationTaps\n        attributedSales\n        id\n      }\n    }\n  }\n  appConfig {\n    automatedNotifications(filters: {isEnabled: true}) {\n      edges {\n        node {\n          id\n          notifType\n          title\n          message\n          delaySeconds\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment InsightsTabNotificationsTable_brand on BrandType {\n  id\n  currencyCode\n  displayName\n  notifications(first: 10, after: \"\", filters: {isPushed: true}) {\n    edges {\n      node {\n        id\n        uuid\n        audiences {\n          audienceName\n          id\n        }\n        body\n        thumbnailUrl\n        timestamp\n        title\n        attributedNotification {\n          attributedSales\n          attributedOrders\n          pushNotificationDeliveries\n          pushNotificationTaps\n        }\n        __typename\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ae8df9ef224b2b53981266a4114b67c";

export default node;
